const ITEMS = [
  "DYNAMIC FEEDER BALANCE",
  "SUB-SECOND EDGE DISPATCH",
  "ZERO-CURTAILMENT ALGORITHMS",
  "GRID-FORMING INVERTER CONTROL",
  "REAL-TIME TELEMETRY ORCHESTRATION",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee-ribbon"
    className="overflow-hidden bg-[#2C4A3A] py-4 select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-[#F5F4F0]/85"
            >
              <span className="px-8">{item}</span>
              <span className="w-1.5 h-1.5 bg-[#B86A28]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
